import * as Types from '../../../../baseType';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InteractiveChapterQueryVariables = Types.Exact<{
  chapterId: Types.Scalars['Int'];
}>;


export type InteractiveChapterQuery = { __typename?: 'Query', getChapter: { __typename?: 'Chapter', storyId: number, chapterId: number, chapterIndex: number, name: string, freeDependencyChapterIndex?: number | null, price: number, isAdult: boolean, story: { __typename?: 'Story', name: string, isMWS: boolean, playType: Types.Story_Play_Type, bundle?: { __typename?: 'StoryBundle', storyBundleId: number } | null, genreKey?: { __typename?: 'StoryGenre', type: string } | null, language?: { __typename?: 'Language', code: string } | null, lastPlay?: { __typename?: 'UserPlayedStory', currentPlayingChapter: { __typename?: 'UserPlayedChapter', withAICustomCharacter?: boolean | null } } | null } } };


export const InteractiveChapterDocument = gql`
    query InteractiveChapter($chapterId: Int!) {
  getChapter(data: {id: $chapterId}) {
    storyId
    chapterId
    chapterIndex
    name
    freeDependencyChapterIndex
    price
    isAdult
    story {
      name
      isMWS
      playType
      bundle {
        storyBundleId
      }
      genreKey {
        type
      }
      language {
        code
      }
      lastPlay {
        currentPlayingChapter {
          withAICustomCharacter
        }
      }
    }
  }
}
    `;

/**
 * __useInteractiveChapterQuery__
 *
 * To run a query within a React component, call `useInteractiveChapterQuery` and pass it any options that fit your needs.
 * When your component renders, `useInteractiveChapterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInteractiveChapterQuery({
 *   variables: {
 *      chapterId: // value for 'chapterId'
 *   },
 * });
 */
export function useInteractiveChapterQuery(baseOptions: Apollo.QueryHookOptions<InteractiveChapterQuery, InteractiveChapterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InteractiveChapterQuery, InteractiveChapterQueryVariables>(InteractiveChapterDocument, options);
      }
export function useInteractiveChapterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InteractiveChapterQuery, InteractiveChapterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InteractiveChapterQuery, InteractiveChapterQueryVariables>(InteractiveChapterDocument, options);
        }
export type InteractiveChapterQueryHookResult = ReturnType<typeof useInteractiveChapterQuery>;
export type InteractiveChapterLazyQueryHookResult = ReturnType<typeof useInteractiveChapterLazyQuery>;
export type InteractiveChapterQueryResult = Apollo.QueryResult<InteractiveChapterQuery, InteractiveChapterQueryVariables>;